import React, { FC, useContext } from 'react';
import clsx from 'clsx';
import { PrivateDiningProps } from './PrivateDining.types';
import { StyledPrivateDining } from './PrivateDining.styles';
import { ComponentProps } from '../../organisms/RFPComponent/RFPComponent.types';
import { serverData } from '../../organisms/RFPComponent/context';
import { RadioButton } from '@marriott/mi-ui-library';

export const PrivateDining: FC<PrivateDiningProps> = props => {
  const { jsonContent }: ComponentProps = useContext(serverData);
  const privateDining = jsonContent?.['instance']?.privateDining?.fieldSet
    ? [...jsonContent['instance']['privateDining']['fieldSet']]
    : [];

  return (
    <StyledPrivateDining data-testid="trc-PrivateDining" data-component-name="m-trc-PrivateDining">
      <div>
        <p className="mb-md-5 pb-2 pb-md-3 pt-xl-5 mt-xl-5 t-title-alt-s t-rc-italic">
          {props?.index}.{jsonContent?.['instance']?.privateDining?.name}
        </p>
      </div>
      <div className="private-dining offset-xl-2 row justify-content-xl-start justify-content-center ">
        <p
          className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 
          col-md-8 m-0 mb-xl-3 mb-2 mb-md-3"
        >{`${privateDining[0]?.fieldName}
            ${privateDining[0]?.mandatory ? '*' : ''}`}</p>
        <div className="dining-prepared d-flex d-flex col-12 col-xl-6 col-md-8 mb-4 mb-md-5 mb-xl-0">
          {privateDining[0]?.inputOptions?.map((item: { dependency: Array<string>; option: string }) => {
            return (
              <RadioButton
                radiobuttonId={`${privateDining[0]?.name} ${item['option']}`}
                radiobuttonName={privateDining[0]?.name + item['option']}
                radiobuttonLabel={item['option']}
                disabled={props.submitted}
                className={clsx(
                  'm-radio-button-sm',
                  'pr-4',
                  `rfp-${privateDining[0]?.name}`,
                  props?.data[0]?.isError ? 'error' : ''
                )}
                labelClassName="t-font-m"
                checked={item['option'] === props?.data[0]?.value}
                onChange={(event: React.ChangeEvent<HTMLInputElement> | undefined) => {
                  props.onDataChange({
                    key: privateDining[0]?.name,
                    value: event?.target?.value ? event?.target?.value : '',
                  });
                }}
                onKeyDown={(event: React.KeyboardEvent) => {
                  if (event?.key === 'Enter' || event?.keyCode === 13) {
                    const target = event?.target as HTMLInputElement;
                    props.onDataChange({
                      key: privateDining[0]?.name,
                      value: target?.value ? target?.value : '',
                    });
                  }
                }}
                value={item['option']}
                setTabIndex={-1}
              />
            );
          })}
        </div>
      </div>
    </StyledPrivateDining>
  );
};
